module.exports = __webpack_public_path__ + "img/LIST.d3b06436.svg";